import { FC } from "react";
import {
  createStyles,
  FormHelperText,
  FormHelperTextProps,
  makeStyles,
} from "@material-ui/core";

import { colors } from "theme/constants";

export type FormHelperTextExtraOwnProps = {
  warning?: boolean;
};

export type FormHelperTextExtraProps = FormHelperTextProps &
  FormHelperTextExtraOwnProps;

const useFormHelperTextExtraStyles = makeStyles(() =>
  createStyles({
    warning: {
      color: `${colors.warning} !important`,
    },
  }),
);

export const FormHelperTextExtra: FC<FormHelperTextExtraProps> = ({
  warning,
  className,
  error,
  ...props
}) => {
  const { warning: warningClassname } = useFormHelperTextExtraStyles();
  let customClassName: string | undefined;
  if (!error && warning) {
    error = true;
    customClassName = warningClassname;
  }
  return (
    <FormHelperText
      error={error}
      className={`${className} ${customClassName ?? ""}`}
      {...props}
    />
  );
};
